<!--
 * @Author: lc
 * @Date: 2022-04-09 15:28:15
 * @LastEditors: lc
 * @LastEditTime: 2022-08-25 16:06:31
 * @Description: 
-->
<template>
  <div class="config">
    <Form ref="configData"
          :model="config"
          action="javascript:void(0)">
      <FormItem label="定时回收盲盒">
        <Input v-model="config.recover_time"
               placeholder="例如10"
               style="width:100px;"></Input>&nbsp;&nbsp;天
      </FormItem>
      <FormItem label="最多赠送人数">
        <Input v-model="config.person_num"
               placeholder="例如5"
               style="width:100px;"></Input>&nbsp;&nbsp;人
      </FormItem>
      <FormItem>
        <Button type="primary"
                @click="handleSubmit('configData')">提交</Button>
      </FormItem>
    </Form>
  </div>
</template>


<script>
export default {
  name: "config",
  data () {
    return {
      config: {
        recover_time: "0",
        person_num: "0"
      }
    };
  },
  created: function () {
    this.getConfig();
  },
  methods: {
    handleSubmit (name) {
      console.log(this.config);
      this.$api.mangheset.edit(this.config).then(res => {
        if (res.code == 200) {
          this.$Message.success("修改成功...");
        }
      });
    },
    getConfig: function () {
      this.$api.mangheset.detail().then(res => {
        if (res.result) {
          this.config = res.result.config;
        }
      });
    }
  }
};
</script>
